formDirective = angular.module('form.setting', [])

formDirective.directive "formSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "$rootScope", "$filter", ($window, $timeout, $compile, $templateCache, ns, translitService, $rootScope, $filter) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  link: (scope, element, attrs, ngModel) ->

    id = attrs.widgetId
    widgetElWrapper = angular.element("[data-block-id=#{id}]").find ns.widgetWrapperClass

    scope.data.disable_form_settings = window.justclick.disableFormSettings;
    scope.data.override_form_action = window.justclick.overrideFormAction;

    scope.accordion = {
      show_form: false
      show_parent_button: false
      show_button: false
      show_action: false
    }


    orderFields = [
      {
        id: "fxc1"
        title: $filter('translate')('widget.form.orderField1')
        name: "show_kupon"
        exist: false
      }
      {
        id: "fxc2"
        title: $filter('translate')('widget.form.orderField2')
        name: "surname"
        exist: false
      }
      {
        id: "fxc3"
        title: $filter('translate')('widget.form.orderField3')
        name: "otchestvo"
        exist: false
      }
      {
        id: "fxc4"
        title: $filter('translate')('widget.form.orderField4')
        name: "phone"
        exist: false
      }
      {
        id: "fxc5"
        title: $filter('translate')('widget.form.orderField5')
        name: "country"
        exist: false
      }
      {
        id: "fxc6"
        title: $filter('translate')('widget.form.orderField6')
        name: "region"
        exist: false
      }
      {
        id: "fxc7"
        title: $filter('translate')('widget.form.orderField7')
        name: "city"
        exist: false
      }
      {
        id: "fxc8"
        title: $filter('translate')('widget.form.orderField8')
        name: "address"
        exist: false
      }
      {
        id: "fxc9"
        title: $filter('translate')('widget.form.orderField9')
        name: "postal"
        exist: false
      }
      {
        id: "fxc10"
        title: $filter('translate')('widget.form.orderField10')
        name: "comment"
        exist: false
      }
      {
        id: "fxc11"
        title: $filter('translate')('widget.form.orderField11')
        name: "offerta"
        exist: false
      }
    ]


    if scope.data.frame_settings.order_fields.length is 0
      scope.data.frame_settings.order_fields = orderFields


    rgba2hex = (rgba) ->
      rgbaStringArray = rgba.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g)
      if rgbaStringArray == null
        [
          rgba
          1
        ]
      else
        rgb = rgbaStringArray[0].split(', ')
        opacity = rgb[3]
        hexResult = if rgb and rgb.length == 4 then '#' + ('0' + parseInt(rgb[0], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) else ''
        [
          hexResult.replace("#", "")
          opacity
        ]

    resizeFrameForm = (count) ->
      if widgetElWrapper.find("iframe")[0]
        scope.data.frame_settings.frame_height = widgetElWrapper.find("iframe")[0].contentWindow.document.body.offsetHeight
        widgetElWrapper.find(".frame-form").css "height", scope.data.frame_settings.frame_height


    getProductsArray = (goods) ->
      productsArr = []
      _.each goods, (good) ->
        if good.hasOwnProperty("name") and good.selected
          productsArr.push good.name
        if good.hasOwnProperty("goods") and good.goods.length > 0
          productsArr = productsArr.concat getProductsArray(good.goods)
      return productsArr

    generateUrl = ->
      productsString = getProductsArray(scope.data.frame_settings.products).join(":")

      fieldsArr = []
      for field in scope.data.frame_settings.order_fields
        fieldsArr.push field.name if field.exist
      fieldsString = fieldsArr.join(",")
      if scope.data.frame_settings.frame_form_color
        color = rgba2hex scope.data.frame_settings.frame_form_color
      url = "#{document.location.origin}/order_form/?goods=#{productsString}&required=#{fieldsString}&btn_css=#{scope.data.frame_settings.frame_button_size} #{scope.data.frame_settings.frame_button_color}&button=#{scope.data.frame_settings.frame_button_value}&font=#{parseInt(scope.data.frame_settings.font_size)}&tag=#{scope.data.frame_settings.tag}&kupon=#{scope.data.frame_settings.kupon}"

      if scope.data.frame_settings.button_type is "custom"
        url += "&image=#{scope.data.image_attributes.source_url}"
      if scope.data.frame_settings.frame_form_color
        url += "&color=#{color[0]}"

      offertField = _.filter(scope.data.frame_settings.order_fields, {name: "offerta"})[0]

      if offertField.exist
        url += "&offerta=#{scope.data.frame_settings.offert_url}"

      if scope.data.frame_settings.utm
        if scope.data.frame_settings.utm.ad_utm_medium is "other"
          url += "&utm[utm_medium]=#{scope.data.frame_settings.utm.ad_other_utm_medium}"
        else if scope.data.frame_settings.utm.ad_utm_medium
          url += "&utm[utm_medium]=#{scope.data.frame_settings.utm.ad_utm_medium}"

        if scope.data.frame_settings.utm.ad_utm_source
          url += "&utm[utm_source]=#{scope.data.frame_settings.utm.ad_utm_source}"
        if scope.data.frame_settings.utm.ad_utm_campaign
          url += "&utm[utm_campaign]=#{scope.data.frame_settings.utm.ad_utm_campaign}"
        if scope.data.frame_settings.utm.ad_utm_content
          url += "&utm[utm_content]=#{scope.data.frame_settings.utm.ad_utm_content}"
        if scope.data.frame_settings.utm.ad_utm_term
          url += "&utm[utm_term]=#{scope.data.frame_settings.utm.ad_utm_term}"

      width = widgetElWrapper.find("iframe").width() || widgetElWrapper.parents(".str-col").width()
      url += "&width=#{width-70}&btn_width=#{width-70}"
      scope.data.frame_settings.frame_url = url

      if offertField.exist
        return url + "&__parent=#{document.location.origin}/shops/bills/formcode/"
      else
        return url

    productChoosed = ->
      selectedArray = []
      for category in scope.data.frame_settings.products
        for group, index in category.goods
          selectedArray.push group if group.selected
      selectedArray.length > 0


    renderFrameForm = (newVal = false, oldVal = false) ->
      return false if scope.data.form_type is "subscription"
      if newVal and oldVal
        return false if newVal is oldVal

      #$rootScope.$broadcast "form:products", productChoosed()

      frameUrl = generateUrl()

      widgetElWrapper.find("iframe").unbind "load"
      widgetElWrapper.find("iframe").on "load", ->
        resizeFrameForm() if scope.data.frame_settings.autoheight
      if widgetElWrapper.find("iframe").length is 0
        widgetElWrapper.html "<div class='frame-form' style='height: #{scope.data.frame_settings.frame_height}px'><iframe style='width: 100%;height:100%;' src='#{frameUrl}'></iframe><div class='frame-form__overlay'></div>"
      else
        widgetElWrapper.find("iframe").attr "src", frameUrl


    scope.renderFrameForm = renderFrameForm

    changeFormTimeout = ->
      $timeout.cancel scope.renderFormTimeout
      scope.renderFormTimeout = $timeout ->
        renderFrameForm()
      , 1000

    changeFormType = (newType) ->
      formhtml = "<div class='strwf__form strwf__form-wrapper-#{id}'><form id='#{id}'></form></div>"
      widgetElWrapper.html formhtml if newType is "subscription"
      renderFrameForm()

    setSelectedFirstProduct = (products) ->
      for category,index in products
        if index is 0
          if category.hasOwnProperty("goods")
            for good, index in category.goods
              good.selected = true
              if good.hasOwnProperty("goods") and good.goods.length
                setSelectedFirstProduct good.goods
          else
            category.selected = true


    setSelectedOldProducts = (oldCategories, goods) ->
      for good, index in goods
        for oldCategory in oldCategories
          if oldCategory.title is good.title and oldCategory.selected
            good.selected = true
          if oldCategory.goods and oldCategory.goods.length > 0 and good.goods and good.goods.length > 0
            setSelectedOldProducts oldCategory.goods, good.goods

    if scope.data.frame_settings.products and scope.data.frame_settings.products.length is 0
      scope.data.frame_settings.products = angular.copy window.justclick.groups
      setSelectedFirstProduct(scope.data.frame_settings.products)
    else
      oldCategories = angular.copy scope.data.frame_settings.products
      scope.data.frame_settings.products = angular.copy(window.justclick.groups)
      setSelectedOldProducts oldCategories, scope.data.frame_settings.products

    changeFrameHeight = (newVal) ->
      widgetElWrapper.find(".frame-form").css "height", newVal

    changeUtm = ->
      scope.data.frame_settings.frame_url = generateUrl()

    listeners = []
    listeners.push scope.$watch "data.form_type", changeFormType
    listeners.push scope.$watch "data.frame_settings.products", renderFrameForm, true
    listeners.push scope.$watch "data.frame_settings.order_fields", renderFrameForm, true
    listeners.push scope.$watch "data.frame_settings.frame_button_color", renderFrameForm, true
    listeners.push scope.$watch "data.frame_settings.frame_button_value", changeFormTimeout, true
    listeners.push scope.$watch "data.frame_settings.frame_button_size", renderFrameForm, true
    listeners.push scope.$watch "data.image_attributes", renderFrameForm, true
    listeners.push scope.$watch "data.frame_settings.button_type", renderFrameForm, true
    listeners.push scope.$watch "data.frame_settings.frame_form_color", changeFormTimeout, true
    listeners.push scope.$watch "data.frame_settings.font_size", changeFormTimeout, true
    listeners.push scope.$watch "data.frame_settings.frame_height", changeFrameHeight, true
    listeners.push scope.$watch "data.frame_settings.utm", changeUtm, true
    listeners.push scope.$watch "data.frame_settings.autoheight", resizeFrameForm, true
    listeners.push scope.$watch "data.frame_settings.offert_url", renderFrameForm, true

    scope.$on "$destroy", ->
      _.each listeners, (listener) ->
        listener()
]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/form/form.directive.coffee